import balanceV1 from './balance/balance.v1.json';
import { hashValue } from './hashing';
import { deepFreeze, parseBalance, parseMap, validateContent, type ArenaMap } from './loaders';
import arenaMap from './maps/arena.json';
import fortressMap from './maps/fortress.json';
import type { Balance } from './schemas';

export * from './hashing';
export * from './loaders';
export * from './schemas';
export { SCENARIOS, getScenario } from './scenarios';

export const MAP_IDS = ['arena', 'fortress'] as const;
export type MapId = (typeof MAP_IDS)[number];

const RAW_MAPS: Record<MapId, unknown> = { arena: arenaMap, fortress: fortressMap };

export const RAW_BALANCE_V1: unknown = balanceV1;

export interface LoadedContent {
  readonly map: ArenaMap;
  readonly balance: Balance;
  readonly balanceHash: string;
  readonly contentHash: string;
}

export function loadMap(id: MapId): ArenaMap {
  return parseMap(RAW_MAPS[id]);
}

export function loadDefaultBalance(): Balance {
  return parseBalance(balanceV1);
}

/**
 * Loads and cross-validates a map + balance pair. The returned objects are deep-frozen,
 * which is how a match freezes its configuration at start.
 */
export function loadContent(mapId: MapId, rawBalance: unknown = balanceV1): LoadedContent {
  const map = loadMap(mapId);
  const balance = parseBalance(JSON.parse(JSON.stringify(rawBalance)));
  validateContent(map, balance);
  const balanceHash = hashValue(balance);
  return deepFreeze({
    map,
    balance,
    balanceHash,
    contentHash: hashValue({ map: map.hash, balance: balanceHash }),
  });
}
